import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  RichTextFieldSchema,
  UrlFieldSchema,
} from './Types';
import { z } from 'zod';

export const FooterLinkTextField = RichTextFieldSchema.extend({
  name: z.literal('linkText'),
  role: z.literal(FieldRole.CtaText),
});

export const FooterLinkUrlField = UrlFieldSchema.extend({
  name: z.literal('linkUrl'),
  role: z.literal(FieldRole.CtaUrl),
});

export const FooterLogoUrlField = ImageFieldSchema.extend({
  name: z.literal('logoUrl'),
  role: z.literal(FieldRole.Logo),
});

export const FooterBlockFieldSchema = z.discriminatedUnion('name', [FooterLogoUrlField]);

export type FooterBlockField = z.infer<typeof FooterBlockFieldSchema>;

export const FooterLinkFieldSchema = z.discriminatedUnion('name', [FooterLinkTextField, FooterLinkUrlField]);

export type FooterLinkField = z.infer<typeof FooterLinkFieldSchema>;

const FooterBlockFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(FooterBlockFieldSchema),
});

export const FooterLinkFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(FooterLinkFieldSchema),
});

export type FooterLinkFieldGroup = z.infer<typeof FooterLinkFieldGroupSchema>;

const FooterStyleOptionsSchema = z.object({
  backgroundColor: z.string().optional(),
});

export const FooterOptionsSchema = z.object({
  style: FooterStyleOptionsSchema.optional(),
  entryCount: z.number().optional(),
  layout: z.literal('standard').optional(),
  colorScheme: ColorSchemeSchema.optional(),
});

export type FooterOptions = z.infer<typeof FooterOptionsSchema>;

export const FooterBlockConfigSchema = z.object({
  options: FooterOptionsSchema,
  type: z.literal(BlockType.Footer),
  fieldGroups: z.tuple([FooterBlockFieldGroupSchema]).rest(FooterLinkFieldGroupSchema),
  version: z.literal(2),
});
